import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BlogPost, blogService } from "~/services/firebaseService";
import AppLayout from "~/pages/AppLayout/AppLayout";
import { Card } from "~/components/Card";

export default function Blog() {
  const { t } = useTranslation();
  const [blogs, setBlogs] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const fetchedData = await blogService.getAllBlogPosts();
        setBlogs(fetchedData);
      } catch (err) {
        setError("Failed to fetch blog posts");
        console.error("Error fetching blog posts:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  const handleRetry = () => {
    setError(null);
    setLoading(true);
    const fetchData = async () => {
      try {
        const fetchedData = await blogService.getAllBlogPosts();
        setBlogs(fetchedData);
      } catch (err) {
        setError("Failed to fetch blog posts");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  };

  return (
    <AppLayout
      title={t("blog.title")}
      loading={loading}
      error={error}
      emptyTitle="No Blog Posts Available"
      emptyMessage="We're working on adding new blog posts. Please check back soon!"
      onRetry={handleRetry}
    >
      {blogs.map((blog) => (
        <Card
          key={blog.id}
          id={blog.id!}
          title={blog.title}
          description={blog.excerpt}
          image={blog.image}
          href={`/blog/${blog.id}`}
          tags={blog.tags}
          meta={{
            author: `By ${blog.author}`,
            date: blog.publishedAt?.toDate().toLocaleDateString()
          }}
        />
      ))}
    </AppLayout>
  );
}
